module.exports = __webpack_public_path__ + "media/images/file-icons/128/003-interface-9a875ead94f807ba809a8436358eeb3f.png";